import React from 'react';
import { Form } from 'react-bootstrap';
import 'assets/css/textcomponent.css';

// 郵便番号を扱うコンポーネント
function ZipCodeComponent(props) {
  const handleChange = (e) => {
    let value = e.target.value;

    // 数字以外の文字を除去
    // 数字のみが許可されるようにする
    if (/^\d*$/.test(value)) {
      // 最大7桁に制限
      if (value.length <= 7) {
        // 更新された値を親コンポーネントに伝える
        if (props.onChange) {
          props.onChange({ target: { value } });
        }
      }
    }
  };

  const handleBlur = (e) => {
    let value = e.target.value;

    // フォーカスアウト時に7桁の場合、nnn-nnnnにフォーマット
    if (value.length === 7) {
      value = value.slice(0, 3) + '-' + value.slice(3, 7);
    }

    // フォーマットした値を再設定
    e.target.value = value;

    // 更新された値を親コンポーネントに伝える
    if (props.onChange) {
      props.onChange(e.target);
    }
    if (props.onBlur) {
      props.onBlur(e.target);
    }
  };

  const handleFocus = (e) => {
    let value = e.target.value;

    // フォーマットした値を再設定
    e.target.value = value.replace(/[^0-9]/g, '');

    // 更新された値を親コンポーネントに伝える
    if (props.onChange) {
      props.onChange(e.target);
    }
  };

  const handlePaste = (e) => {
    // クリップボードの内容を取得
    let pastedValue = e.clipboardData.getData('Text');

    // 数字以外の文字を除去
    pastedValue = pastedValue.replace(/[^0-9]/g, '');

    // 最大7桁に制限
    pastedValue = pastedValue.slice(0, 7);

    // 値をセットして親コンポーネントに伝える
    e.target.value = pastedValue;
    if (props.onChange) {
      props.onChange(e.target);
    }

    // デフォルトの貼り付け動作を防ぐ
    e.preventDefault();
  };

  return (
    <Form.Control
      type="text"
      inputMode="tel"
      className={props.className}
      value={props.value}
      disabled={props.disabled}
      maxLength={7}
      onFocus={handleFocus}
      onChange={handleChange}
      onBlur={handleBlur}
      onPaste={handlePaste}
      style={{
        background: props.error ? 'lightpink' : '',
      }}
    />
  );
}

export default ZipCodeComponent;
